import { forwardRef } from 'react';

export interface Props {
  trackId: string;
  allowAutoplay: boolean;
}

// FsLightbox cloneElement()s custom sources and attaches a ref to measure
// offsetWidth/offsetHeight — the root element must forward that ref.
export const SoundCloud = forwardRef<HTMLDivElement, Props>(
  ({ allowAutoplay, trackId }, ref) => {
    const src = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${trackId}&color=%23ff5500&visual=true&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=true`;
    return (
      <div ref={ref}>
        <iframe
          allow={allowAutoplay ? 'autoplay' : ''}
          height="300"
          src={src}
          title={trackId}
          width="100%"
        />
      </div>
    );
  },
);

SoundCloud.displayName = 'SoundCloud';
